module.exports = __webpack_public_path__ + "5ffdd6f9588967d0a48b166825097e0e.pdf";